export default class ArticleBlog {
  constructor(el) {
    this.el = el
    this.picto = el.querySelector('.article-blog--picto')
    this.init()
  }

  init() {
    if (!this.picto) return
    this.picto.addEventListener('click', () => this.copyLink())
  }

  copyLink() {
    navigator.clipboard.writeText(window.location.href).then(() => {
      const toast = document.createElement('div')
      toast.className = 'article-blog--toast'
      toast.textContent = 'Lien copié !'
      document.body.appendChild(toast)

      requestAnimationFrame(() => {
        requestAnimationFrame(() => toast.classList.add('is-visible'))
      })

      setTimeout(() => {
        toast.classList.remove('is-visible')
        toast.addEventListener('transitionend', () => toast.remove(), { once: true })
      }, 2000)
    })
  }
}
